import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { filterDate } from './common/utils'

Vue.config.productionTip = false

Vue.filter('formatDate', filterDate)
Vue.use(ElementUI)

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
